import React from 'react';
import { LoginML } from './LoginML';

const Login = (props) => {
  return (
    <div data-log={JSON.stringify({
      oid: 'page_login',
      isPage: true,
      params: {
        initUrl: window.location.origin+window.location.pathname,
      },
      events: ['_pv', '_pd'],
    })}>
      <LoginML props={props} />
    </div>
  );
};
export default Login;
